import { useEffect } from "preact/hooks";
import confetti from "canvas-confetti";
import type { Reward } from "../engine/rewards";
import { playMotif } from "../audio/sfx";
import { reducedMotion } from "../lib/motion";

type CelebrationProps = { reward: Reward; onDone: () => void };

const DURATION_MS: Record<number, number> = { 3: 4000, 4: 5000 };

/** Fullscreen T3/T4 takeover — rank-ups and rare/secret plaques. At most
    one of these fires per session (see engine/rewards.ts pickHeadlineReward);
    everything else lands as a compact row on the Session Card instead. */
export function Celebration({ reward, onDone }: CelebrationProps) {
  const rare = reward.tier >= 4;
  const duration = reducedMotion() ? 1600 : (DURATION_MS[reward.tier] ?? 4000);

  useEffect(() => {
    playMotif();
    if (!reducedMotion()) {
      const colors = rare ? ["#F0BE43", "#8A5CF0", "#D6F24B"] : ["#D6F24B", "#E9FF7A"];
      confetti({
        particleCount: rare ? 140 : 80,
        spread: 70,
        origin: { y: 0.4 },
        colors,
        shapes: ["square"],
        scalar: 0.8,
      });
    }
    const t = setTimeout(onDone, duration);
    return () => clearTimeout(t);
    // eslint-disable-next-line
  }, []);

  return (
    <div class={"celebration" + (rare ? " celebration-rare" : "")} onClick={onDone}>
      <p class="stage-kicker">{reward.kind === "rank" ? "New rank" : "Unlocked"}</p>
      <p class="display celebration-title">{reward.title}</p>
      {reward.detail && <p class="stage-detail">{reward.detail}</p>}
      <p class="mono celebration-skip">tap to continue</p>
    </div>
  );
}
